import { NgTemplateOutlet } from '@angular/common';
import { Component, input, model, signal, output } from '@angular/core';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { TranslocoDirective } from '@ngneat/transloco';
import { UntilDestroy } from '@ngneat/until-destroy';
import { AlertComponent } from '@pedix-workspace/angular-ui-alert';
import {
  FormValidationComponent,
  InputCheckboxComponent,
} from '@pedix-workspace/angular-ui-form-reactive';
import {
  IconLoadingComponent,
  IconPriceDiscountComponent,
  IconShippingComponent,
  IconEditComponent,
} from '@pedix-workspace/angular-ui-icons';
import { ButtonComponent } from '@pedix-workspace/angular-ui-button';
import { CurrencyFormatPipe } from '@pedix-workspace/pedixapp-shared-pipes';
import { DeliveryType, TypesOfShippings, ShippingEstimate } from '@pedix-workspace/utils';
import { ShippingCostResponse } from '@pedix-workspace/shared-delivery';
import { ShippingOptionsSelectorComponent } from '../shipping-options-selector/shipping-options-selector.component';

@UntilDestroy()
@Component({
  selector: 'app-shipping-cost-response',
  templateUrl: './shipping-cost-response.component.html',
  styleUrls: ['./shipping-cost-response.component.scss'],
  standalone: true,
  imports: [
    TranslocoDirective,
    AlertComponent,
    InputCheckboxComponent,
    FormValidationComponent,
    FormsModule,
    NgTemplateOutlet,
    CurrencyFormatPipe,
    IconPriceDiscountComponent,
    IconLoadingComponent,
    IconShippingComponent,
    IconEditComponent,
    ButtonComponent,
    ShippingOptionsSelectorComponent,
  ],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class ShippingCostResponseComponent {
  readonly calculatingShippingCost = input.required<boolean>();
  readonly shippingCostResponse = input.required<ShippingCostResponse | null>();
  readonly isFormSubmitted = input.required<boolean>();
  readonly selectedParcelOption = input<ShippingEstimate | null>(null);

  readonly outOfDeliveryZoneConfirmed = signal<boolean>(false);

  readonly selectedParcelOptionChange = output<ShippingEstimate>();

  protected typesOfShippings = TypesOfShippings;
  protected deliveryTypes = DeliveryType;

  onParcelOptionSelected(option: ShippingEstimate | null) {
    this.selectedParcelOptionChange.emit(option!);
  }

  formatDeliveryDate(dateString: string): string {
    try {
      const date = new Date(dateString);
      const dayMonth = date.toLocaleDateString('es-AR', {
        day: 'numeric',
        month: 'long'
      });
      const weekday = date.toLocaleDateString('es-AR', { weekday: 'long' });
      
      return `Entrega estimada: ${weekday} ${dayMonth}`;
    } catch {
      return 'Fecha de entrega por confirmar';
    }
  }
}
